// extracted by mini-css-extract-plugin
module.exports = {"infoMessage":"styles_infoMessage__1OiSW"};